import React, {
  useState, useReducer, useEffect, // useRef,
} from 'react'
import { Row, Col, Modal } from 'antd'
// import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

import __ from './languages/parser'

// Components
import MakerMenu from './components/menu/Menu'
import WhiteBoard from './components/WhiteBoard'
import Cart from './components/Cart'
import Elements from './components/menu/Elements'
import Tuto from './components/tuto/Tuto'
import SelectedElement from './components/elements/SelectedElement'
import ModalOpenComposition from './components/elements/ModalOpenComposition'
import ModalSaveComposition from './components/elements/ModalSaveComposition'
// Hooks
import useEventListener from './hookreducer/events'
import { useIsSmallDevice } from './hookreducer/hooks'

// Reducers
import { reducer, initialState } from './hookreducer/mainReducer'
import handleShortkeys from './engine/shortkeys'

// Calculs
import { calculateWholeDimensions } from './engine/positions'
import { getTotalPrice } from './engine/prices'

// Tools
import removeQueryParameter from './tools/queryParameters'

import { GET_COMPOSITION_URL, POST_COMPOSITION_URL } from './static/url'

const SMALL_BASE_RES = 2.5

const getComposition = (compositionId, callback) => {
  if (!compositionId) {
    callback(new Error('no Composition Id'))
  }

  fetch(GET_COMPOSITION_URL + compositionId, {
    method: 'GET',
    mode: 'cors',
  })
    .then((res) => res.json())
    .then((json) => callback(null, json))
    .catch((err) => callback(err))
}

const postComposition = (composition, callback) => {
  if (!composition) {
    callback(new Error('no Composition'))
    return
  }

  const {
    title, orderId, res, baseRes, vRes, woodColor, metalColor, elements = [],
  } = composition

  const schema = {
    title,
    orderId,
    res,
    baseRes,
    vRes,
    woodColor,
    metalColor,
    elements,
  }
  fetch(POST_COMPOSITION_URL, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(schema),
  })
    .then((response) => response.json())
    .then((json) => callback(null, json.id))
    .catch((err) => callback(err))
}

const MakerPage = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const [currentStep, setCurrentStep] = useState(0)
  const [isTagged, setTag] = useState(false)
  const [isQuotes, setQuotes] = useState(false)
  const [shortkeys, setShortkeys] = useState(true)
  const [cartVisibility, setCartVisibility] = useState(false)
  const [wholeDimensions, setWholeDimensions] = useState({
    minX: 0, minY: 0, maxX: 0, maxY: 0, wholeWidth: 0, wholeHeight: 0,
  })
  const [totalPrice, setTotalPrice] = useState(null)
  const [publicModel, setPublicModel] = useState(false)
  const [modalOpenComposition, setModalOpenComposition] = useState(false)
  const [modalSaveComposition, setModalSaveComposition] = useState(false)
  const [compositionId, setCompositionId] = useState(null)
  const [loadingSaveComposition, setLoadingSaveComposition] = useState(false)

  // const ref = useRef(null)
  const isSmall = useIsSmallDevice()

  const continuousSave = () => {
    localStorage.setItem('gassienMaker', JSON.stringify({
      elements: state.elements,
      title: state.title,
      res: state.res,
      vRes: state.vRes,
      woodColor: state.woodColor,
      metalColor: state.metalColor,
    }))
  }

  const reset = () => {
    dispatch({
      type: 'reset',
      baseRes: isSmall ? SMALL_BASE_RES : null,
      showTuto: false,
    })
  }

  const handleKeydown = (e) => {
    if (shortkeys) {
      e.stopPropagation()
      handleShortkeys(e, dispatch, state)
    }
  }

  useEventListener('keydown', handleKeydown)

  const addElement = (elementType) => {
    dispatch({
      type: 'addElement',
      elementType,
    })
  }

  const addBox = (dimension) => {
    dispatch({
      type: 'addBox',
      dimension,
    })
  }

  const selectElement = (id) => {
    dispatch({
      type: 'selectElement',
      id,
    })
  }

  const removeSelectedElement = () => {
    dispatch({
      type: 'removeElement',
      id: state.selectedElement,
    })
  }

  const removeElement = (id) => {
    dispatch({
      type: 'removeElement',
      id,
    })
  }

  const setOriginalPosition = (position) => {
    if (position.x !== state.originalPosition.x || position.y !== state.originalPosition.y) {
      dispatch({
        type: 'setOriginalPosition',
        position,
      })
    }
  }

  const setBoxVisibility = (id, view) => {
    dispatch({
      type: 'setBoxVisibility',
      id,
      view,
    })
  }

  const setBoxQuotesVisibility = (id, viewQuotes) => {
    dispatch({
      type: 'setBoxQuotesVisibility',
      id,
      viewQuotes,
    })
  }

  const save = () => {
    localStorage.setItem('gassienMaker', JSON.stringify({
      elements: state.elements,
      title: state.title,
      res: state.res,
      vRes: state.vRes,
      woodColor: state.woodColor,
      metalColor: state.metalColor,
    }))
  }

  const saveAs = () => {
    const data = JSON.stringify({
      elements: state.elements,
      title: state.title,
      res: state.res,
      vRes: state.vRes,
      woodColor: state.woodColor,
      metalColor: state.metalColor,
    })

    const filename = state.title ? `${state.title}.gmaker` : 'Gassien - no title.gmaker'

    const type = 'application/json'

    const file = new Blob([data], { type })

    const a = document.createElement('a')
    const url = URL.createObjectURL(file)
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()

    setTimeout(() => {
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    }, 10)
  }

  const saveComposition = () => {
    setLoadingSaveComposition(true)
    postComposition(state, (err, id) => {
      setLoadingSaveComposition(false)
      if (!err && id) {
        setCompositionId(id)
        setModalSaveComposition(true)
      } else {
        Modal.error({
          title: __('Impossible to save compossition'),
        })
      }
    })
  }

  const setShowTuto = (showTuto) => {
    dispatch({
      type: 'setShowTuto',
      showTuto,
    })
  }

  const getElementFromLocalStorage = () => {
    try {
      const elements = JSON.parse(localStorage.getItem('gassienMaker'))
      return elements
    } catch (err) {
      return {}
    }
  }

  const load = () => {
    try {
      const params = document.location.search.slice(1).split('&').reduce((acc, s) => {
        const [k, v] = s.split('=')
        return Object.assign(acc, { [k]: v })
      }, {})


      if (params.model) {
        getComposition(params.model, (err, res) => {
          if (err || !res.schema) {
            removeQueryParameter()
            const retrievedElements = getElementFromLocalStorage()
            dispatch({
              type: 'loadElements',
              localState: retrievedElements,
            })
          } else {
            reset()
            dispatch({
              type: 'loadElements',
              localState: res.schema,
            })
            setPublicModel(true)
          }
        })
      } else {
        const retrievedElements = getElementFromLocalStorage()
        reset()
        dispatch({
          type: 'loadElements',
          localState: retrievedElements,
        })
      }
    } catch (error) {
      reset()
      setShowTuto(true)
    }
  }

  const setComposition = (composition) => {
    reset()
    dispatch({
      type: 'loadElements',
      localState: composition,
    })
  }

  const setItemPosition = (id, itemPosition) => {
    dispatch({
      type: 'setItemPosition',
      id,
      itemPosition,
    })
  }

  const setTitle = (title) => {
    dispatch({
      type: 'setTitle',
      title,
    })
  }

  const setRes = (newRes) => {
    dispatch({
      type: 'setRes',
      res: newRes,
    })
  }

  const setVRes = (vRes) => {
    dispatch({
      type: 'setVRes',
      vRes,
    })
  }

  const setWoodColor = (woodColor) => {
    dispatch({
      type: 'setWoodColor',
      woodColor,
    })
  }

  const setMetalColor = (metalColor) => {
    dispatch({
      type: 'setMetalColor',
      metalColor,
    })
  }

  useEffect(() => {
    load()
    if (isSmall) {
      dispatch({
        type: 'setBaseRes',
        baseRes: SMALL_BASE_RES,
      })
    }
  }, [])

  useEffect(() => {
    if (publicModel) {
      removeQueryParameter()
      setPublicModel(false)
    }
    continuousSave()
    setWholeDimensions(calculateWholeDimensions(state.elements.filter((el) => ['gridPF', 'gridMF', 'gridGF', 'gridGS', 'gridMS'].indexOf(el.type) >= 0), state.baseRes, state.res))
  }, [state])

  useEffect(() => {
    if (state.showTuto) {
      // disableBodyScroll(ref)
    } else {
      // enableBodyScroll(ref)
    }
  }, [state.showTuto])

  useEffect(() => {
    const { totalTtc } = getTotalPrice(state.elements, state.metalColor, state.woodColor)
    setTotalPrice(totalTtc)
  }, [state.elements.length, state.metalColor, state.woodColor])

  return (
    <div
      className="gassien-maker drawerContainer"
      style={{
        fontSize: isSmall ? '18px' : '14px',
        fontFamily: 'Nunito Sans',
        fontWeight: '300',
      }}
    >
      <MakerMenu
        addElement={addElement}
        addBox={addBox}
        removeSelectedElement={removeSelectedElement}
        selectElement={selectElement}
        selectedElement={state.selectedElement}
        elements={state.elements}
        save={save}
        saveAs={saveAs}
        load={load}
        reset={reset}
        isTagged={isTagged}
        setTag={setTag}
        setTitle={setTitle}
        title={state.title}
        res={state.res}
        setRes={setRes}
        isQuotes={isQuotes}
        setQuotes={setQuotes}
        setVRes={setVRes}
        vRes={state.vRes}
        setMetalColor={setMetalColor}
        setWoodColor={setWoodColor}
        metalColor={state.metalColor}
        woodColor={state.woodColor}
        setShortkeys={setShortkeys}
        setBoxVisibility={setBoxVisibility}
        setBoxQuotesVisibility={setBoxQuotesVisibility}
        fileName={state.fileName}
        setCartVisibility={setCartVisibility}
        totalPrice={totalPrice}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        setShowTuto={setShowTuto}
        setModalOpenComposition={setModalOpenComposition}
        saveComposition={saveComposition}
        loadingSaveComposition={loadingSaveComposition}
      />

      <div className="board" id="fullBoard">
        <Row style={{ width: '100%' }}>
          <Col span={isSmall ? 24 : 5} style={{ paddingRight: isSmall ? '0px' : '2.4em' }}>
            <Elements
              addElement={addElement}
              currentStep={currentStep}
              setShortkeys={setShortkeys}
              setMetalColor={setMetalColor}
              setWoodColor={setWoodColor}
              metalColor={state.metalColor}
              woodColor={state.woodColor}
              setCartVisibility={setCartVisibility}
              setTag={setTag}
              isTagged={isTagged}
              setQuotes={setQuotes}
              isQuotes={isQuotes}
              addBox={addBox}
            />
          </Col>

          {isSmall
            ? (
              <SelectedElement
                selectedElement={state.selectedElement}
                elements={state.elements}
                removeElement={removeElement}
              />
            )
            : null}


          <Col span={isSmall ? 24 : 19}>
            <WhiteBoard
              elements={state.elements}
              selectElement={selectElement}
              selectedElement={state.selectedElement}
              removeElement={removeElement}
              setOriginalPosition={setOriginalPosition}
              offsetX={state.originalPosition.x}
              offsetY={state.originalPosition.y}
              setItemPosition={setItemPosition}
              isTagged={isTagged}
              isQuotes={isQuotes}
              res={state.res}
              baseRes={state.baseRes}
              vRes={state.vRes}
              wholeDimensions={wholeDimensions}
            />
          </Col>

        </Row>

      </div>

      <Cart
        cartVisibility={cartVisibility}
        setCartVisibility={setCartVisibility}
        elements={state.elements}
        woodColor={state.woodColor}
        metalColor={state.metalColor}
      />

      <Tuto
        showTuto={state.showTuto}
        setShowTuto={setShowTuto}
      />

      <ModalOpenComposition
        visible={modalOpenComposition}
        hide={() => setModalOpenComposition(false)}
        getComposition={getComposition}
        setComposition={setComposition}
      />

      <ModalSaveComposition
        visible={modalSaveComposition}
        hide={() => setModalSaveComposition(false)}
        compositionId={compositionId}
      />

    </div>
  )
}

export default MakerPage
